import { APIResponse } from "@/types/api";
import http from "@/composables/api";
import { VarianDataPayload, VarianDataResponse } from "@/types/interface/varian";

async function createVarian(payload: VarianDataPayload) {
  return await http.post<APIResponse<VarianDataResponse>>("goods-variant/create", payload);
}

async function updateVarian(idUnit = '', payload: VarianDataPayload) {
  return await http.patch<APIResponse<VarianDataResponse>>(`goods-variant/update?id=${idUnit}`, payload);
}

async function getVarian(page = 1, limit = 10, queryParam = "") {
  let pagination = true;
  if (page == 0){
    pagination = false;
  }
  return await http.get<APIResponse<VarianDataResponse>>(`goods-variant?is_pagination=${pagination}&page=${page}&limit=${limit}${queryParam}`);
}

async function findVarian(idUnit = "") {
  return await http.get<APIResponse<VarianDataResponse>>(`goods-variant/detail?id=${idUnit}`);
}

async function deleteVarian(idUnit = "") {
  return await http.delete<APIResponse<VarianDataResponse>>(`goods-variant/delete?id=${idUnit}`);
}

export default {
  createVarian,
  updateVarian,
  getVarian,
  findVarian,
  deleteVarian
};